import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '@tcc-mono/shared/app-config';
import { BaseService, Response } from '@tcc-mono/shared/data-access';
import { WebNotification, WebNotificationInbox } from '@tcc-mono/vandijk/shared/data-access/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NotificationService extends BaseService<WebNotification> {
  public constructor(
    _http: HttpClient,
    @Inject(APP_CONFIG) appConfig: IAppConfig
  ) {
    super(_http, appConfig);
    this.path = 'api/notifications';
  }

  public getUnhandled() {
    return this.getAll({ unhandled: 1, per_page: 50 });
  }

  public getWebInbox(): Observable<WebNotificationInbox> {
    return this._http
      .get<Response<WebNotificationInbox>>(this.getUrl(`${this.path}/web_inbox`))
      .pipe(map((response) => response.data ?? { unhandled: [], handled: [], unhandled_count: 0 }));
  }

  public getUnhandledCount(): Observable<number> {
    return this._http
      .get<Response<{ count: number }>>(this.getUrl(`${this.path}/unhandled_count`))
      .pipe(map((response) => response.data?.count ?? 0));
  }

  public handle(id: number): Observable<Response<WebNotification>> {
    return this.postChild<Response<WebNotification>>(null, `/${id}/handle`);
  }
}
